export function isNameAvailable(
  name: string,
  taken: { id: string; name: string }[],
  selfId?: string,
): boolean {
  const key = name.trim().toLocaleLowerCase("sv");
  return (
    key !== "" &&
    !taken.some(
      (t) => t.id !== selfId && t.name.toLocaleLowerCase("sv") === key,
    )
  );
}
